import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolderUpload: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="folder-upload"><path d="M12 19.25V14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M14.5 15.5L12 13L9.5 15.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.25 19.25H2.75V3.75H10L12 6.75H21.25V19.25H15.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFolderUpload;
